:host{box-shadow:0 0 8px #0003}
/*# sourceMappingURL=header.component-USFMGMSA.css.map */
